import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './core/services/spinner.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    private title: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private translate: TranslateService,
        private spinnerService: SpinnerService
    ) {
        router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
    }

    ngOnInit() {
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            })
            .filter((route) => route.outlet === 'primary')
            .mergeMap((route) => route.data)
            .subscribe((event) => {
                this.title = event['title'];
                this.setPageTitle();
            });

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.setPageTitle();
        });
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.spinnerService.show('omsSpinner');
        }
        if (event instanceof NavigationEnd) {
            this.spinnerService.hide('omsSpinner');
        }

        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.spinnerService.hide('omsSpinner');
        }
        if (event instanceof NavigationError) {
            this.spinnerService.hide('omsSpinner');
        }
    }

    setPageTitle(): void {
        const translated: string = this.translate.instant(`title.${this.title}`) + this.translate.instant(`title.oms`);
        this.titleService.setTitle(translated);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts